import {
	getFinancialOverview, getFinancialSettings, updateFinancialSettings,
	listPayouts, approvePayout, rejectPayout, markPayoutPaid,
} from '@/services/academy/financial.service'

export default {
	namespaced: true,
	state: {
		overview:        null,
		overviewStatus:  'init',
		settings:        null,
		settingsStatus:  'init',
		payouts:         { data: [], meta: { total: 0 } },
		payoutsStatus:   'init',
	},
	getters: {
		getOverview:       (s) => s.overview,
		getOverviewStatus: (s) => s.overviewStatus,
		getSettings:       (s) => s.settings,
		getSettingsStatus: (s) => s.settingsStatus,
		getPayouts:        (s) => s.payouts,
		getPayoutsStatus:  (s) => s.payoutsStatus,
	},
	mutations: {
		SET_OVERVIEW(state, v)        { state.overview = v },
		SET_OVERVIEW_STATUS(state, v) { state.overviewStatus = v },
		SET_SETTINGS(state, v)        { state.settings = v },
		SET_SETTINGS_STATUS(state, v) { state.settingsStatus = v },
		SET_PAYOUTS(state, v)         { state.payouts = v },
		SET_PAYOUTS_STATUS(state, v)  { state.payoutsStatus = v },
	},
	actions: {
		async fetchOverview({ commit }, params) {
			commit('SET_OVERVIEW_STATUS', 'pending')
			try {
				const { data } = await getFinancialOverview(params)
				commit('SET_OVERVIEW', data)
				commit('SET_OVERVIEW_STATUS', 'init')
			} catch { commit('SET_OVERVIEW_STATUS', 'error') }
		},
		async fetchSettings({ commit }) {
			commit('SET_SETTINGS_STATUS', 'pending')
			try {
				const { data } = await getFinancialSettings()
				commit('SET_SETTINGS', data.data)
				commit('SET_SETTINGS_STATUS', 'init')
			} catch { commit('SET_SETTINGS_STATUS', 'error') }
		},
		async saveSettings({ dispatch }, payload) {
			await updateFinancialSettings(payload)
			dispatch('fetchSettings')
		},
		async fetchPayouts({ commit }, params) {
			commit('SET_PAYOUTS_STATUS', 'pending')
			try {
				const { data } = await listPayouts(params)
				commit('SET_PAYOUTS', data)
				commit('SET_PAYOUTS_STATUS', 'init')
			} catch { commit('SET_PAYOUTS_STATUS', 'error') }
		},
		async approve({ dispatch }, { id, notes }) {
			await approvePayout(id, { admin_notes: notes })
			dispatch('fetchPayouts')
		},
		async reject({ dispatch }, { id, notes }) {
			await rejectPayout(id, { admin_notes: notes })
			dispatch('fetchPayouts')
		},
		async markPaid({ dispatch }, { id, notes }) {
			await markPayoutPaid(id, { admin_notes: notes })
			dispatch('fetchPayouts')
		},
	},
}
